import { useTheme } from "@mui/material/styles";
import React from "react";
import { colorCircleStyles } from "../../styles/colorCircleStyles";

type ColorCircleProps = {
  value: string;
};

const ColorCircleRenderer: React.FC<ColorCircleProps> = ({ value }) => {
  const theme = useTheme();
  const styles = colorCircleStyles(theme);

  return (
    <div
      style={{
        ...(styles.colorCircle as React.CSSProperties),
        backgroundColor: value.toLowerCase(),
      }}
    />
  );
};

export default ColorCircleRenderer;
